// const base_url = 'https://proweaveremail.com/shopifysendingemail/';
// // test email
// const test_email = true;

// const company_name = 'Nexli';
// const company_email = 'bforbishih@outlook.com';

// const email = test_email ? 'webtestreceive@gmail.com' : company_email;

// $(document).on('submit', '#ContactForm', function (e) {
//     e.preventDefault();

//     const form = this;

//     // reCAPTCHA validation (same logic as reference style)
//     if (
//         grecaptcha.getResponse() === "" &&
//         $(form).attr('form-name') !== 'Send Us A Message'
//     ) {
//         alert("Please verify that you are not a robot!");
//         return false;
//     }

//     const formdata = new FormData(form);

//     // Honeypot (added from reference pattern improvement)
//     if (formdata.get('Robot')) return;

//     const form_name = `${company_name} | ${$(form).attr('form-name')}`;

//     formdata.append('form_name', form_name);
//     formdata.append('company_name', company_name);
//     formdata.append('email', email);

//     $.ajax({
//         url: base_url,
//         type: 'POST',
//         data: formdata,
//         dataType: 'json',
//         processData: false,
//         contentType: false,

//         success: function (response) {
//             $('#prompt_message').html(response.message);

//             // match reference behavior (disable submit button)
//             $(form).find("input[type='submit'], button[type='submit']").prop('disabled', true);

//             form.reset();
//         },

//         error: function () {
//             $('#prompt_message').html('<p class="error">Failed to send email.</p>');
//         }
//     });
// });

// const base_url = 'https://proweaveremail.com/shopifysendingemail/';
// const test_email = true;

// const company_name = 'Nexli';
// const company_email = 'bforbishih@outlook.com';
// const email = test_email ? 'spproweaver@gmail.com' : company_email;

// // Form submission handler
// $(document).on('submit', '#SPForm', function (e) {
//     e.preventDefault();

//     const form = this;
//     const formdata = new FormData(form);

//     // Optional spam protection (honeypot support if field exists)
//     if (formdata.get('Robot')) return;

//     // Basic validation (email required check fallback)
//     const emailField = $(form).find('input[type="email"]').val();
//     if (!emailField) {
//         $('#prompt_message').html('<p class="error">Email is required.</p>');
//         return;
//     }

//     // Append required email system fields
//     formdata.append('company_name', company_name);
//     formdata.append('email', email);

//     $.ajax({
//         url: base_url,
//         type: 'POST',
//         data: formdata,
//         processData: false,
//         contentType: false,
//         dataType: 'json',

//         beforeSend: function () {
//             // optional UI lock
//             $(form).find("input[type='submit']").prop('disabled', true);
//         },

//         success: function (response) {
//             $('#prompt_message').html(response.message || 'Message sent successfully.');

//             form.reset();
//         },

//         error: function () {
//             $('#prompt_message').html('<p class="error">Failed to send message. Please try again.</p>');
//             $(form).find("input[type='submit']").prop('disabled', false);
//         }
//     });
// });

const base_url = 'https://proweaveremail.com/shopifysendingemail/';
const test_email = true;

const company_name = 'Nexli';
const company_email = 'bforbishih@outlook.com';
const email = test_email ? 'webtestreceive@gmail.com' : company_email;

document.addEventListener('submit', function (e) {
    const form = e.target;

    if (!form || form.id !== 'SPForm') return;

    e.preventDefault();

    const formdata = new FormData(form);

    // 🪤 spam protection (optional)
    if (formdata.get('Robot')) return;

    // 📦 extract fields (based on Shopify structure)
    const name = form.querySelector('input[type="text"]')?.value || '';
    const emailVal = form.querySelector('input[type="email"]')?.value || '';
    const phone = form.querySelector('input[type="tel"]')?.value || '';
    const message = form.querySelector('textarea')?.value || '';
    const address = document.getElementById('SPForm-address')?.value || '';

    // 📤 normalize email payload (THIS is what server reads)
    formdata.set('Full_Name', name);
    formdata.set('Email_Address', emailVal);
    formdata.set('Phone', phone);
    formdata.set('Address', address);
    formdata.set('Message', message);

    // 📌 required backend fields
    formdata.set('form_name', `${company_name} | Contact Form`);
    formdata.set('company_name', company_name);
    formdata.set('email', email);

    fetch(base_url, {
        method: 'POST',
        body: formdata
    })
    .then(res => res.json().catch(() => ({ message: 'Message sent' })))
    .then(data => {
        const msgBox = document.getElementById('prompt_message');
        if (msgBox) {
            msgBox.innerHTML = `<p class="success">${data.message || 'Message sent successfully'}</p>`;
        }
        form.reset();
    })
    .catch(() => {
        const msgBox = document.getElementById('prompt_message');
        if (msgBox) {
            msgBox.innerHTML = `<p class="error">Failed to send email.</p>`;
        }
    });
});